<template>
  <div>
    <p
      v-if="!isEnableSave"
      class="text-right"
    >* {{ header.month }} 월은 <a :href="`/project/${projectId}/tab/${boardId}/write/${작성된문서Id}`" class="font-semibold">작성된 문서</a>가 있습니다. </p>

    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" :fieldReadonly="this.$route.params && !!this.$route.params.postId" @input="checkMonth(`${header.year}-${header.month}-1`)" />

    <!-- 부가정보 : 안전보건협의체-->
    <write-grid-container title="안전보건협의체" v-model="form.subInfo" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <OpinionEditor v-if="dataType === 'opinions'" v-model="form.subInfo" is-print />
          <div v-else-if="dataType === 'file' && form.subInfo[value]" class="print-input">{{ form.subInfo[value].fileName }}</div>
          <NumberInput v-else-if="dataType === 'number'" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'textarea'" class="print-textarea">{{ form.subInfo[value] }}</div>
          <div v-else class="print-input">{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <OpinionEditor v-if="dataType === 'opinions'" v-model="form.subInfo" :readonly="board.readonly" />
          <FileUploader v-else-if="dataType === 'file'" v-model="form.subInfo[value]" />
          <NumberInput v-else-if="dataType === 'number'" v-model="form.subInfo[value]" />
          <ml-textarea v-else-if="dataType === 'textarea'" rows="5" v-model="form.subInfo[value]" class="w-full mb-0" />
          <date-selector v-else-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import FileUploader from "@/components/FileUploader.vue";
import OpinionEditor from "@/views/boards/single-page/817/OpinionEditor.vue";

import DateUtil from "@/util/DateUtil.js";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    RadioTypeCheck,
    FileDownloadPost,
    NumberInput,
    DateSelector,
    CustomOptionSelector,
    FileUploader,
    OpinionEditor,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      isEnableSave: true,
      작성된문서Id: null,
      gridContainerOptions: {
        classes: ["", "", "row2", "row2", "row2", "row3", "row3", "writeGridLineItem ", "writeGridLineItem"],
        dataTypes: ["date", "file", "number", "number", "number", "number", "number", "textarea", "opinions"],
        labels: ["회의 일자", "회의록 업로드", "심의대상(건)", "의결(건)", "조건부의결(건)", "기각(건)", "재검토(건)", "승인내역", "종사자 의견 및 조치계획"],
        values: ["회의일자", "회의록업로드", "심의대상", "의견", "조건부의결", "기각", "재검토", "승인내역", "의견목록"],
      },
      form: {
        monthDate: "",
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    postId() {
      return this.$route.params.postId;
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        this.checkMonth(`${value.year}-${value.month}-1`);
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});
    // 의견목록은 배열. 종사자의견·조치계획·조치결과는 OpinionEditor 가 목록·검색용으로 합쳐 넣는 글이라 키만 남겨 둔다.
    this.form.subInfo.의견목록 = [];
    this.form.subInfo.특이사항없음 = false;
    for (const key of ["종사자의견", "조치계획", "조치결과"]) this.form.subInfo[key] = "";

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    async checkMonth(date) {
      // fieldId가 없으면 건너뜀
      if (!this.form.stdInfo.field_id) return;

      const targetMonth = DateUtil.getMonthDates(date);

      const projectId = this.$route.params.proj_id;
      const boardId = this.$route.params.boardId;
      const fieldId = this.form.stdInfo.field_id;
      const page = 1;
      const perPage = 10000;
      const dateTarget = "body.monthDate";
      const dateBegin = targetMonth.start;
      const dateEnd = targetMonth.end;

      this.form.monthDate = dateBegin;

      const conditions = [];
      conditions.push({ key: dateTarget, operator: ">=", value: dateBegin });
      conditions.push({ key: dateTarget, operator: "<=", value: dateEnd });

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, fieldId, page, perPage, conditions });
      const list = this.$store.state.board.postListInfo.data;

      // 해당 월에 이미 작성된 문서가 있으면 저장버튼을 없앤다.
      if (list.length > 0) {
        this.작성된문서Id = list[0].id || null;

        if (!this.postId || (`${this.postId}` !== `${this.작성된문서Id}`)) {
          this.isEnableSave = false;
          this.$emit("EnableSave", false);
          return;
        }
      }

      this.isEnableSave = true
      this.$emit("EnableSave", true);
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}

.sub::v-deep {
  .row2 {
    grid-row-start: auto;
  }
  .row3 {
    grid-row-start: auto;
  }
}

@media print, screen and (min-width: 1200px) {
  .sub::v-deep {
    .row2 {
      grid-row-start: 2;
    }
    .row3 {
      grid-row-start: 3;
    }
  }
}
</style>
